<div class="spacer"></div>

@if (hasOrgAccess) {
  <lib-container class="purchased-allotments" title="Purchased Allotments">
    <div actions>
      <lib-button type="primary" (click)="showProducts()" [disabled]="!canViewProducts">
        Purchase
      </lib-button>
    </div>

    <div actions>
      <lib-button type="primary" (click)="showAllocate(purchased)">
        Allocate
      </lib-button>
    </div>

    @if (!purchased_loading) {
      <table mat-table [dataSource]="purchased">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let allotment">{{ allotment.name }}</td>
        </ng-container>

        <ng-container matColumnDef="purchased">
          <th mat-header-cell *matHeaderCellDef>Purchased</th>
          <td mat-cell *matCellDef="let allotment" class="small-width">{{ allotment.purchased }}</td>
        </ng-container>

        <ng-container matColumnDef="allocated">
          <th mat-header-cell *matHeaderCellDef>Allocated</th>
          <td mat-cell *matCellDef="let allotment" class="small-width">{{ allotment.assigned }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let allotment" class="table-actions"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="purchase_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: purchase_columns;"></tr>

      </table>
    } @else {
      <lib-content-loader></lib-content-loader>
    }

  </lib-container>

  <div class="h-divider"></div>
}

@if (profile) {
  <lib-container title="Organization Allotments" class="margin-top">
    @if (!assigned_loading) {
      <table mat-table [dataSource]="allotments">
        <ng-container matColumnDef="org">
          <th mat-header-cell *matHeaderCellDef class="quarter-width">Org</th>
          <td mat-cell *matCellDef="let allotment" class="quarter-width">{{ allotment.org_name }}</td>
        </ng-container>

        <ng-container matColumnDef="assessment">
          <th mat-header-cell *matHeaderCellDef class="quarter-width">Assessment</th>
          <td mat-cell *matCellDef="let allotment" class="quarter-width">{{ allotment.name }}</td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef class="small-width">Total</th>
          <td mat-cell *matCellDef="let allotment" class="small-width">{{ allotment.assigned }}</td>
        </ng-container>

        <ng-container matColumnDef="consumed">
          <th mat-header-cell *matHeaderCellDef class="small-width">Consumed</th>
          <td mat-cell *matCellDef="let allotment" class="small-width">{{ allotment.used }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="large-width"></th>
          <td mat-cell *matCellDef="let allotment" class="table-actions large-width">
            <div class="button-container right-justify">
              @if ([1].includes(profile.role_id) && (allotment.assigned - allotment.used) > 0) {
                <lib-button mat-button (click)="unallocate(allotment)">
                  Unallocate
                </lib-button>
              }
              <lib-button mat-button (click)="assign(allotment)">
                Assign
              </lib-button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="assign_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: assign_columns;"></tr>
      </table>
    } @else {
      <lib-content-loader></lib-content-loader>
    }
  </lib-container>
}
